module.exports = __webpack_public_path__ + "assets/instrument-tech.svg?4c2e5dbbf8012defa73ad901cc73794d";